import React, { useState, useRef, useEffect } from "react";
import CreateNewPost from "./CreateNewPost";
import ModifyPost from "./ModifyPost";
import Post from "./Post";
import "./blogpage.css";
import * as environment from '../../coreservices/environment'

const DisplayAllPosts = () => {
    // managing states below
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    // const [allPosts, setAllPosts] = useState([
    //     {
    //         id: 1,
    //         title: "React",
    //         content:
    //             "React is a JavaScript library created for building fast and interactive user interfaces for web and mobile applications. It is an open-source, component-based, front-end library responsible only for the application’s view layer. In Model View Controller (MVC) architecture, the view layer is responsible for how the app looks and feels. React was created by Jordan Walke, a software engineer at Facebook. "
    //     },
    //     {
    //         id: 2,
    //         title: "Django",
    //         content:
    //             "Django is a free and open source, full-stack web application framework, written in Python. Django Python is a framework for perfectionists with deadlines. With it, you can build better Web apps in much less time, and in less code."
    //     }
    // ]);

    const [allPosts, setAllPosts] = useState([]);

    useEffect(() => {
        // if (emailID != '') {
        getBlog()
        // }

    }, [])

    const getBlog = async () => {

        try {
            const response = await fetch(`${environment.apiUrl}/blog`); // Replace with your API endpoint
            if (!response.ok) {
                throw new Error('Network response was not ok.');
            }
            const fetchedData = await response.json();
            console.log('====================================');
            console.log("fetchedData", fetchedData);
            console.log('====================================');

            setAllPosts(fetchedData)


        } catch (error) {
            console.error(error.message);
        }

    }




    // const [allPosts, setAllPosts] = useState([]) // can also be used
    const [isCreateNewPost, setIsCreateNewPost] = useState(false);
    const [isModifyPost, setIsModifyPost] = useState(false);
    const [editPostId, setEditPostId] = useState("");

    // Initialize useRef (to empty title and content once saved)
    const getTitle = useRef();
    const getContent = useRef();

    // function 1 (accepting title in state by user input)
    const savePostTitleToState = (event) => {
        setTitle(event.target.value);
    };

    // function 2 (accepting content/description in state by user input)
    const savePostContentToState = (event) => {
        setContent(event.target.value);
    };

    // function 3 (to save title and content in allPosts state)
    const savePost = (event) => {
        event.preventDefault();
        const id = Date.now();
        setAllPosts([...allPosts, { title, content, id }]);
        getTitle.current.value = "";
        getContent.current.value = "";
        toggleCreateNewPost();
    };

    // function 4 (toggle create new post visibility)
    const toggleCreateNewPost = () => {
        setIsCreateNewPost(!isCreateNewPost);
    };

    // function 5 (toggle post editing)
    const toggleModifyPostComponent = () => {
        setIsModifyPost(!isModifyPost);
    };

    // function 6 (to edit posts)
    const editPost = (id) => {
        setEditPostId(id);
        toggleModifyPostComponent();
    };

    // function 7 (to update the posts)
    const updatePost = (event) => {
        event.preventDefault();
        const updatedPost = allPosts.map((eachPost) => {
            if (eachPost.id === editPostId) {
                return {
                    ...eachPost,
                    title: title || eachPost.title,
                    content: content || eachPost.content
                };
            }

            return eachPost;
        });
        setAllPosts(updatedPost);
        toggleModifyPostComponent();
    };

    // function 8 (to delete posts)
    const deletePost = (id) => {
        const modifiedPost = allPosts.filter((eachPost) => {
            return eachPost.id !== id;
        });
        setAllPosts(modifiedPost);
    };

    if (isCreateNewPost) {
        return (
            <>
                <CreateNewPost
                    savePostTitleToState={savePostTitleToState}
                    savePostContentToState={savePostContentToState}
                    getTitle={getTitle}
                    getContent={getContent}
                    savePost={savePost}
                />
                {/* Cancel Button */}
                <button
                    className="btn btn-danger cancel-button"
                    onClick={toggleCreateNewPost}
                >
                    Cancel
                </button>
            </>
        );
    } else if (isModifyPost) {
        const post = allPosts.find((post) => {
            return post.id === editPostId;
        });

        return (
            <>
                <ModifyPost
                    title={post.title}
                    content={post.content}
                    updatePost={updatePost}
                    savePostTitleToState={savePostTitleToState}
                    savePostContentToState={savePostContentToState}
                    toggleCreateNewPost={toggleCreateNewPost}
                />
                <button
                    className="btn btn-danger cancel-update-button"
                    onClick={toggleModifyPostComponent}
                >
                    Cancel
                </button>
            </>
        );
    }

    return (
        <>
            <h2>All Posts</h2>

            <button
                className="btn btn-outline-info button-edits create-post"
                onClick={toggleCreateNewPost}
            >
                Create New
            </button>

            {!allPosts.length ? (
                <div>
                    <li>There are no posts yet.</li>
                </div>
            ) : (
                allPosts.map((eachPost, index) => (
                    <Post
                        id={eachPost.blogId}
                        key={eachPost.blogId}
                        title={eachPost.title}
                        content={eachPost.content}
                        editPost={editPost}
                        deletePost={deletePost}
                    />
                ))
            )}

        </>
    );
};
export default DisplayAllPosts;
